import React from 'react';
import { LinkTo, Toolbar } from '@common/components';
import { useTranslation } from 'react-i18next';
import footerClasses from './Footer.module.scss';

export default function Footer() {
  const { t } = useTranslation('app\\Footer', { useSuspense: false });

  const routes = [
    { label: 'linkLegal', prefix: '/info/', href: 'legal-advice' },
    { label: 'linkPrivacy', prefix: '/info/', href: 'privacy-policy' },
    { label: 'linkCookies', prefix: '/info/', href: 'cookies' },
    { label: 'linkSupport', prefix: '/', href: 'support' },
    { label: 'linkCredits', prefix: '/info/', href: 'credits' },
  ];

  return (
    <Toolbar className={footerClasses.footer}>
      <div>
        <nav className={footerClasses.nav}>
          <div className={footerClasses.links}>
            {routes.map((route, index) => (
              <LinkTo
                key={`link_${index}`}
                textDecorationNone
                href={route.prefix + route.href}
              >
                {t(route.label)}
              </LinkTo>
            ))}
          </div>
        </nav>
        <p className={footerClasses.copyright}>{t('copyright')}</p>
      </div>
      <div>
        <img
          alt="itenlearning-logo"
          src="/img/itenlearning-logo.svg"
          width={180}
        />
      </div>
    </Toolbar>
  );
}
